import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, Sparkles } from 'lucide-react';
const FloatingContactButtons = () => {
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showCall, setShowCall] = useState(false);
  const [showRipple, setShowRipple] = useState(false);
  const whatsappNumber = "089537 86652";
  const phoneNumber = " 089537 86652";
  const whatsappMessage = "Hello! I'm interested in your jewellery collection. Can you please help me?";
  useEffect(() => {
    const timer1 = setTimeout(() => setShowWhatsApp(true), 500);
    const timer2 = setTimeout(() => setShowCall(true), 800);
    const timer3 = setTimeout(() => setShowRipple(true), 1000);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {showRipple && (
        <div className="absolute inset-0">
          <div className="absolute bottom-0 right-0 w-28 h-32 bg-[#25D366]/20 rounded-full animate-ping"></div>
          <div className="absolute bottom-0 right-0 w-30 h-40 bg-[#1e3a5f]/10 rounded-full animate-ping delay-300"></div>
        </div>
      )}
      <div className={`transform transition-all duration-500 ease-out ${
        showWhatsApp ? 'translate-x-0 opacity-100 rotate-0' : 'translate-x-32 opacity-0 rotate-45'
      }`}>
        <div className="relative group">
          <div className="absolute inset-0 bg-[#25D366] rounded-full blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="relative bg-[#25D366] hover:bg-[#20b859] text-white p-3.5 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl block"
          >
            <MessageCircle size={18} />
            <span className="absolute -top-1 -right-1 bg-red-500 rounded-full w-3 h-3 animate-pulse"></span>
          </a>
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800 text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none shadow-lg">
            💬 WhatsApp
            <div className="absolute -right-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-gray-800 transform rotate-45"></div>
          </span>
        </div>
      </div>
      <div className={`transform transition-all duration-500 ease-out delay-300 ${
        showCall ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-32 opacity-0 scale-50'
      }`}>
        <div className="relative group">
          <div className="absolute inset-0 bg-[#1e3a5f] rounded-full blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
          <a
            href={`tel:${phoneNumber}`}
            className="relative bg-[#1e3a5f] hover:bg-[#153057] text-white p-3.5 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl block"
          >
            <Phone size={18} />
          </a>
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800 text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none shadow-lg">
            📞 Call Now
            <div className="absolute -right-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-gray-800 transform rotate-45"></div>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FloatingContactButtons;